import DOMPurify from "dompurify";

export const sanitize = (html) => ({
  __html: DOMPurify.sanitize(html || ""),
});
